const en = {
    language:'English',
    menu:{
        title: 'SD-Holographic',
        home:'Home',
        block:'Blocks',
        assets:'Tokens',
        history:'TXNS',
    },
    home:{
        amount:'Total TxAmount',
        assetsTotal:'Tokens Amount',
        height:'Latest Block',
        newtrading:'Latest Transactions',

        trading_amount:'Trading Volume',
        trading:'Trading Volume (30 Days)',
        charts:['',''],

        blocklist:'Latest Block',
        head1:['Block Height','Block Hash','TxAmount','Close Time'],

        tradinglist:'Latest Transactions',
        head2:['TxHash','Type','Amount','Time'],

        web:['Official Website','SD-Charger','SD-Cable','SD-Wallet'],
        email:'Email',
    },

    assets:{
        tit:'Tokens Overview',
        tit2:'Token',
        tit3:'Issuer',
        tit4:'Issuance',
        number:'#',
        more: 'Load More',
        nomore: 'No More Data'
    },

    assets_detail: {
        from: 'Issuer',
        amount: 'Issuance',
        total: 'Circulation',
        desc: 'Introduction',
        trading: 'Trading Volume (7 Days)',
        transactions: 'TXNS',
        addrratio: 'Ratio',
        hash: 'TxHash',
        type: 'Type',
        time: 'Time',
        loadmore: 'Load More',
        address: 'Address',
        number: 'Amount',
        ratio:	'Ratio',
        tradingvolume: 'Amount'
    },

    wallet: {
        home: 'Home',
        wallet_address: 'Address',
        tipqr:	'View QR Code',
        tipcopy: 'Copy Address',
        balance: 'Balance',
        passport: 'Tokens',
        more: 'More',
        record: 'TXNS',
        hash: 'TxHash',
        type: 'Type',
        num: 'Amount',
        time: 'Time',
        incoming: 'Into',
        outgoing: 'Out',
        other: 'Other',
        loadmore: 'Load More',
        token: 'Tokens',
        quantity: 'Amount',
        from: 'Issuer'
    },

    block:{
        tit:'Block',
        head:['Block Height','Block Hash','Amount','Close Time'],

        tit2:'Block Details',

        tit3:'TXNS',
        head2:['TxHash','From','Type','Gas Fee','Time'],

        info:['TxAmount','Block Height','Close Time','Current Block Hash','Root TxHash','Previous Block Hash']
    },
    hash:{
        tit:'TxHash',
        tit2:'TxResult',
        list:['Type','Source','Receiver','Block Height','Status','Amount','Fee','Time','Memo','Issuer'],
        text:['Description','Credit Amount'],
        smartContract: 'Smart Contract',
        contractCode: 'Contract Code',
        contractArg: 'Contract Arguments',
        contractAddress: 'Contract Address',
        contractMethod: 'Contract Method',
        codeAddress: 'Code Address',
        codeType: 'Code Type',
        argType: 'Arguments Type',
        codeVersion: 'Contract Version',
        contractResult: 'Contract Results',
        contractEvent: 'Contract Events',
        contractOperator: 'Operator',
        contractEventValue: 'Event Value',
        contractEventName: 'Event Name',
        contractOperateResult: 'Operate Result',
    },
    account:{
        tit:'Wallet Address',
        contractTit: 'Contract Address',
        account:'Account address',
        balance:'balance',
        contractInfo: 'View Contract Code',
        txs:'Transfers',
        contract:'Contract',
        method:'Method',
        params:'Params',
        query:'Query',
        result:'Result',
        success:'Success',
        fail:'Fail',
        copy:'Copy',
    },
    history:{
        tit:'TXNS',
        head:['TxHash','Type','Amount','Time'],
    },
    nodata:'No Data',
    more:'Load More',
    nothing:'Nothing',
    nomore:'No More',
    erraccount:'The TxHash / Block / Address cannot be searched.',
    errblock:'The TxHash / Block / Address cannot be searched.',
    errhash:'The TxHash / Block / Address cannot be searched.',
    searcherr:'Please enter the search content',
    search:'Address / Block / TxHash / Token',
    e404:'404',
    backhome:'Home',
    copy: 'Copy Address',
    copyContract:'Copy contract address',
    qr: 'View wallet address QR code',
    qrContract: 'View contract address QR code',
    copysuc:'Address copied to clipboard!',
    copyerr:'cpoy faild！',
    enter:'please enter...',
    fee:'Fee',

    payment:'Transfer',
    offerCreate:'Create Order',
    offerCancel:'Cancel Order',
    accountSet:'AccountSet',
    multipayment: 'Bulk Transfer',
    trustSet:'Credit',
    signerSet: 'SignerListSet',
    contractUpload: 'Contract Upload',
    contractDeploy: 'Contract Deploy',
    contractCall: 'Contract Call',
    other:'Other',

    success:'success',
    error:'error',
    note:'Note',
    disableSecret: 'Disable secret',
    enableSecret: 'Enable secret',
    defaultSpread: 'Default spread',
    defaultNoSpread: 'Default no Spread',
    signerQuorum: 'signer quorum',
    signerList: 'signer list',
    copyright:'SDChain Alliance, Toronto,Canada.'
}

export default en
